import { Project } from "../../project/models/Project";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { Account } from "../models/Account";
import { AccountStats, AccountUser } from "../models/AccountUser";
import { ApiClient } from "../models/ApiClient";

export const AccountApi = {
  getAccount: async (accountId: string) => {
    return await jwtAuthAxios().get<Account>(`/accounts/${accountId}`);
  },

  listUsers: async (accountId: string) => {
    return await jwtAuthAxios().get<AccountUser[]>(
      `/accounts/${accountId}/users`
    );
  },

  listProjects: async (accountId: string) => {
    return await jwtAuthAxios().get<Project[]>(
      `/accounts/${accountId}/projects`
    );
  },

  getStats: async (accountId: string) => {
    return await jwtAuthAxios().get<AccountStats>(
      `/accounts/${accountId}/stats`
    );
  },

  listApiClients: async (accountId: string) => {
    return await jwtAuthAxios().get<ApiClient[]>(
      `/accounts/${accountId}/api-clients`
    );
  },
};
